
    const html = "<section class=\"container container-spacer offer\"> <div ng-if=!app.user.public ng-include=\"'" + require("modules/users/client/views/profile/activate.client.view.html") + "'\"></div> <div ui-view></div> </section> ";
    angular.module('ng').run(['$templateCache', function($templateCache){
      $templateCache.put('/modules/offers/views/offer.client.view.html', html);
    }]);
    module.exports = '/modules/offers/views/offer.client.view.html';
  